var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('task-filter',{on:{"change":_vm.onChange}}),_c('br'),(_vm.data.length > 0)?_c('a-row',{attrs:{"gutter":16}},_vm._l((_vm.data),function(item,key){return _c('a-col',{key:key,staticClass:"gutter-row",attrs:{"span":12}},[_c('task-point-team',{attrs:{"source-data":item}})],1)}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }